import { createContext, useContext } from 'react';

/** Where a deliberate opening of the panel comes from (usage event `whats-new.open`). */
export type WhatsNewOrigin = 'sidebar' | 'sidebar-glow' | 'tooltip';

type WhatsNewContextType = {
  /** Opens the « Nouveautés » panel on the whole history. */
  openWhatsNew: (from?: WhatsNewOrigin) => void;
  /** The panel is on screen: whatever opens by itself (a guided tour) waits for it to close. */
  panelOpen: boolean;
};

export const WhatsNewContext = createContext<WhatsNewContextType>({ openWhatsNew: () => undefined, panelOpen: false });

export function useWhatsNew() {
  return useContext(WhatsNewContext);
}
